<router-outlet></router-outlet>
<ng2-toasty [position]="'top-right'"></ng2-toasty>
<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
